PJQ.colors = {};

PJQ.colors.ColorPicker = class {
	constructor($el, options = {}) {
		this.$el = $el;
		this.options = _.defaults(options, {
			format: 'auto'
		});
		this.initPicker();
	}

	initPicker() {
		this.$el.colorpicker(this.options).on('change', _.bind(function (e) {
			if (typeof this.options.onChange === 'function') {
				this.options.onChange(e.value);
			}
		}, this));
	}

	getColor() {
		return this.$el.colorpicker('getValue')
	}

	setColor(color) {
		return this.$el.colorpicker('setValue', color)
	}
};

PJQ.colors.SimpleColorPicker = class {
	constructor($el, options = {}) {
		this.colors = [
			{
				hex: PJQ.constants.colors.BLUE,
				name: 'Blue'
			},
			{
				hex: PJQ.constants.colors.PURPLE,
				name: 'Purple'
			},
			{
				hex: PJQ.constants.colors.PINK,
				name: 'Pink'
			},
			{
				hex: PJQ.constants.colors.RED,
				name: 'Red'
			},
			{
				hex: PJQ.constants.colors.ORANGE,
				name: 'Orange'
			},
			{
				hex: PJQ.constants.colors.YELLOW,
				name: 'Yellow'
			},
			{
				hex: PJQ.constants.colors.GREEN,
				name: 'Green'
			},
			{
				hex: PJQ.constants.colors.CYAN,
				name: 'Cyan'
			},
			{
				hex: PJQ.constants.colors.GRAY,
				name: 'Gray'
			},
			{
				hex: PJQ.constants.colors.BLACK,
				name: 'Black'
			}
		];

		this.$el = $el;
		this.$picker = null;
		this.color = options.color ? options.color : this.colors[0].hex;
		this.options = options;
		this.render();
	}

	setColor(color){
		this.color = color;
		this.render();
	}

	render() {
		let template = new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'color-picker');
		PJQ.templating.TemplateRenderer.renderTemplate(true, template, this.$el, {
			colors: this.colors,
			color: this.color
		}, _.bind(function ($el) {
			this.$picker = $el;
			$el.find('.color-item').on('click', _.bind(this.colorPicked, this));
		}, this));
	}

	toggle() {
		if (this.$picker) {
			if (this.$picker.hasClass('hidden')) {
				this.$picker.removeClass('hidden');
			}
			else {
				this.$picker.addClass('hidden');
			}
		}
	}

	show() {
		if (this.$picker) {
			this.$picker.removeClass('hidden');
		}
	}

	hide() {
		if (this.$picker) {
			this.$picker.addClass('hidden');
		}
	}

	colorPicked(e) {
		e.stopPropagation();
		this.color = $(e.currentTarget).data('color');
		if (typeof this.options.onColorPicked === 'function') {
			this.options.onColorPicked(this.color);
		}
		this.hide();
	}

	remove(e) {
		if (this.$picker && this.$picker.length > 0) {
			this.$picker.remove();
		}
	}
}